import { call, put, takeEvery } from 'redux-saga/effects';
import download from 'downloadjs';
import callApi from 'utils/callApi';
import qs from 'qs';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const FETCH_ERA_STATISTICS = 'FETCH_ERA_STATISTICS';
export const FETCH_ERA_STATISTICS_SUCCESS = 'FETCH_ERA_STATISTICS_SUCCESS';
export const FETCH_ERA_STATISTICS_FAIL = 'FETCH_ERA_STATISTICS_FAIL';
export const FETCH_ERA = 'FETCH_ERA';
export const FETCH_ERA_SUCCESS = 'FETCH_ERA_SUCCESS';
export const FETCH_ERA_FAIL = 'FETCH_ERA_FAIL';
export const GET_ERA_DOCUMENT = 'GET_ERA_DOCUMENT';
export const GET_ERA_DOCUMENT_SUCCESS = 'GET_ERA_DOCUMENT_SUCCESS';
export const GET_ERA_DOCUMENT_FAIL = 'GET_ERA_DOCUMENT_FAIL';
// Reducer
export default function eraStatisticsReducer(state = { data: {}, loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_ERA_STATISTICS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_ERA_STATISTICS_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_ERA_STATISTICS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_ERA_SUCCESS:
      return {
        ...state,
        data: Object.keys(state.data).reduce((payerAccumulator, currentPayer) => ({
          ...payerAccumulator,
          [currentPayer]: Object.keys(state.data[currentPayer]).reduce((eraAccumulator, currentEra) => ({
            ...eraAccumulator,
            [currentEra]: {
              ...state.data[currentPayer][currentEra],
              ...payload.data['Check Number'] === currentEra ? {
                ERA: payload.data,
              } : {},
            },
          }), {}),
        }), {}),
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchEraStatistics(payload) {
  return { type: FETCH_ERA_STATISTICS, payload };
}

export function fetchEraStatisticsSuccess(payload) {
  return { type: FETCH_ERA_STATISTICS_SUCCESS, payload };
}

export function fetchEraStatisticsFail(payload) {
  return { type: FETCH_ERA_STATISTICS_FAIL, payload };
}

export function fetchEra(payload) {
  return { type: FETCH_ERA, payload };
}

export function fetchEraSuccess(payload) {
  return { type: FETCH_ERA_SUCCESS, payload };
}

export function fetchEraFail(payload) {
  return { type: FETCH_ERA_FAIL, payload };
}

export function getEraDocument(payload) {
  return { type: GET_ERA_DOCUMENT, payload };
}

export function getEraDocumentSuccess(payload) {
  return { type: GET_ERA_DOCUMENT_SUCCESS, payload };
}

export function getEraDocumentFail(payload) {
  return { type: GET_ERA_DOCUMENT_FAIL, payload };
}

// Requests
export function requestFetchEraStatistics(payload) {
  return callApi('claim_md/era_info/search/', 'POST', payload);
}

export function requestFetchEra(check_number) {
  return callApi('/claim_md/era_code/search/', 'POST', {
    filters: [
      {
        name: 'check_number',
        operation: 'eq',
        val: check_number,
      }
    ],
    'sort_by': [
      {
        name: 'id',
        sort: 'asc'
      }
    ], 
    'limit': 10,
    'offset': 0
  });
}

export function requestDownloadEraDocument({ href }) {
  return download(href);
}

export function requestGetEraDocument(payload) {
  return callApi('claim_md/era_document/', 'POST', payload);
}

// Sagas
function* fetchEraStatisticsSaga(action) {
  const { triggerLoading, ...otherProps } = action.payload;
  try {
    const res = yield call(requestFetchEraStatistics, otherProps);
    yield put(fetchEraStatisticsSuccess({
      data: res.data,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchEraStatisticsFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* fetchEraSaga(action) {
  const { triggerLoading, check_number } = action.payload;
  try {
    const res = yield call(requestFetchEra, check_number);
    yield put(fetchEraSuccess({
      data: res.data[0] || {},
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchEraFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* getEraDocumentSaga(action) {
  try {
    const res = yield call(requestGetEraDocument, action.payload);
    const src = process.env.REACT_APP_API_ROOT
        ? `${process.env.REACT_APP_API_ROOT}${res.data['File Url']}${res.data['File Name']}`
        : `${res.data['File Url']}${res.data['File Name']}`;
    window.open(src, '_blank');
    yield put(getEraDocumentSuccess(res.data));
  } catch (err) {
    yield put(getEraDocumentFail(err.data));
  }
}

export function* eraStatisticsSaga() {
  yield takeEvery(FETCH_ERA_STATISTICS, fetchEraStatisticsSaga);
  yield takeEvery(FETCH_ERA, fetchEraSaga);
  yield takeEvery(GET_ERA_DOCUMENT, getEraDocumentSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/eraStatistics.js